import React, { useState } from 'react';

export default function SmsComplianceCheckboxes({ colorClass = 'text-pink-600', ringClass = 'focus:ring-pink-500' }) {
    const [optInTx, setOptInTx] = useState(false);
    const [optInPromo, setOptInPromo] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);

    return (
        <div className="space-y-3 pt-3 pb-1 animate-fade-in">
            <label className="flex items-start gap-2 cursor-pointer">
                <input 
                    type="checkbox" 
                    checked={optInTx}
                    onChange={(e) => setOptInTx(e.target.checked)}
                    className={`mt-0.5 h-4 w-4 shrink-0 ${colorClass} rounded ${ringClass} border-gray-300 cursor-pointer`} 
                />
                <span className="text-xs text-gray-600 leading-tight">
                    By checking this box and submitting this form, you consent to receive transactional text messages for booking updates and event reminders from Host-it!. Reply STOP to opt out. Reply HELP for help. Standard message and data rates may apply. Message frequency may vary.
                </span>
            </label>
            <label className="flex items-start gap-2 cursor-pointer">
                <input 
                    type="checkbox" 
                    checked={optInPromo}
                    onChange={(e) => setOptInPromo(e.target.checked)}
                    className={`mt-0.5 h-4 w-4 shrink-0 ${colorClass} rounded ${ringClass} border-gray-300 cursor-pointer`} 
                />
                <span className="text-xs text-gray-600 leading-tight">
                    By checking this box and submitting this form, you consent to receive text messages for marketing from Host-it!. Reply STOP to opt out. Reply HELP for help. Message and data rates may apply. Message frequency may vary.
                </span>
            </label>
            <label className="flex items-start gap-2 cursor-pointer">
                <input 
                    type="checkbox" 
                    checked={agreeTerms}
                    onChange={(e) => setAgreeTerms(e.target.checked)}
                    className={`mt-0.5 h-4 w-4 shrink-0 ${colorClass} rounded ${ringClass} border-gray-300 cursor-pointer`} 
                />
                <span className="text-xs text-gray-600 leading-tight">
                    I agree to the <a href={`${window.location.origin}/#terms-of-service`} target="_blank" rel="noopener noreferrer" className={`${colorClass} hover:underline font-medium`} onClick={(e)=>e.stopPropagation()}>Terms and Conditions</a> and <a href={`${window.location.origin}/#privacy-policy`} target="_blank" rel="noopener noreferrer" className={`${colorClass} hover:underline font-medium`} onClick={(e)=>e.stopPropagation()}>Privacy Policy</a>.
                </span>
            </label>
        </div>
    );
}